import { dehydrate, QueryClient } from '@tanstack/react-query'
import { EUserAuthQueryKey } from './user-auth.types'
import userAuthService from './user-auth.service'
import { Cookie } from '@repo/tools'
import type { UserGetAgentByUsernameParams, UserGetAgentParams } from '../api'

export const userAuthDetailsOptions = () => {
  return {
    queryKey: [EUserAuthQueryKey.USER_AUTH_DETAILS],
    queryFn: () => userAuthService.details(),
    enabled: !!Cookie.get('access_token'),
  }
}

export const prefetchUserAuthDetails = async () => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(userAuthDetailsOptions())
  return dehydrate(queryClient)
}

export const featureFlagsOptions = (options?: {
  refetchOnWindowFocus?: boolean
  refetchOnMount?: boolean
  refetchOnReconnect?: boolean
  staleTime?: number
}) => ({
  queryKey: ['feature-flags'],
  queryFn: userAuthService.getFeatureFlags,
  refetchOnWindowFocus: options?.refetchOnWindowFocus ?? true,
  refetchOnMount: options?.refetchOnMount ?? true,
  refetchOnReconnect: options?.refetchOnReconnect ?? true,
  staleTime: options?.staleTime ?? 0,
})

export const getAgentOptions = (
  params: UserGetAgentParams,
  enabled: boolean,
) => ({
  queryKey: ['agent-profile', params],
  queryFn: () => userAuthService.getAgent(params),
  enabled: enabled,
})

export const getAgentByUsernameOptions = (
  params: UserGetAgentByUsernameParams,
  enabled: boolean,
) => ({
  queryKey: ['agent-profile-by-username', params],
  queryFn: () => userAuthService.getAgentByUsername(params),
  enabled: enabled,
})
